import React from 'react';

import { Outlet } from 'react-router-dom';

const TransferContent = () => {
  return <Outlet />;
};

export default TransferContent;
